class InitiativeBackend {
    init() {
        this.$container = $("#edit-initiative");

        if (this.$container.length === 0) {
            return;
        }

        this.initCardToggle();
        this.initChanges();
        this.initLawsuits();
        this.initAutoToggle();
        this.initPlaceChange();
    }

    initCardToggle() {
        this.$container.find(".collapse").on("show.bs.collapse", event => {
            let $collapsible = $(event.currentTarget);
            let $icon = $collapsible.closest(".card").find("button i");
            $icon.removeClass("fa-caret-up").addClass("fa-caret-down");
        });

        this.$container.find(".collapse").on("hide.bs.collapse", event => {
            let $collapsible = $(event.currentTarget);
            let $icon = $collapsible.closest(".card").find("button i");
            $icon.removeClass("fa-caret-down").addClass("fa-caret-up");
        });
    }

    initPlaceChange() {
        $('.edit-place').on("click", event => {
            $('.place-searcher').show();
        });
    }

    initChanges() {
        this.$modal = $("#changes-modal");

        this.$container.find("a.show-changes").on("click", event => {
            let $tableRow = $(event.currentTarget).closest("tr");
            let id = $tableRow.attr("data-id");

            let $modalBottom = this.$modal.find(".modal-bottom");
            $modalBottom.html('<div class="modal-body"><div class="spinner-border text-center" role="status">\n' +
                '  <span class="sr-only">Loading...</span>\n' +
                '</div></div>');
            this.$modal.modal();

            let editId = $tableRow.closest("table").find("b").closest("tr").attr("data-id");

            $.get("/initiative-backend/changes?id=" + id + "&edit-id=" + editId, data => {
                $modalBottom.html(data);

                $modalBottom.find(".btn-primary").on("click", event => {
                    let changes = JSON.parse($modalBottom.find("#changes").attr("data-changes"));

                    for (const key in changes) {
                        this.$container.find("input[name='"+ key +"'], select[name='"+ key +"']").val(changes[key]["new"]);
                    }

                    this.$modal.find(".alert").show();
                });
            });
        });
    }

    initLawsuits() {
        this.$container.find(".template").hide();

        this.$newLawsuitButton = this.$container.find(".add-new-lawsuit");

        this.$newLawsuitButton.on("click", () => {
            let $container = this.$container.find(".lawsuit-container").last();
            let $newContainer = $container.clone();

            let firstLawsuit = $container.hasClass("template");

            $container.after($newContainer);

            $newContainer.show();
            $newContainer.removeClass("template");
            $newContainer.find("select").val("null");
            $newContainer.find("input").val("");
            $newContainer.find("span.title").html("Neue Klageinstanz");
            $newContainer.find("input[type='hidden']").remove();
            if (!firstLawsuit) {
                $newContainer.find("input, select").each((index, element) => {
                    let $element = $(element);
                    let newName = $element.attr("name").replace(/(\d+)/, function() {return arguments[1]*1+1});
                    $element.attr("name", newName);
                });
            }

            let randomId = Math.random().toString(36).substr(2, 5);
            $newContainer.find("h5 button").attr("data-target", "#" + randomId);
            $newContainer.find(".collapse").attr("id", randomId).removeClass("show");
        });

        $(document).on("click", ".delete-lawsuit", (event) => {
            let $btn = $(event.currentTarget);
            $btn.closest(".lawsuit-container").remove();
        });

        this.$container.find("form").on("submit", (event) => {
            this.$container.find(".lawsuit-container.template").remove();

            let $container = this.$container.find(".lawsuit-container");

            $container.each((index, element) => {
                let empty = true;

                $(element).find("input, select").each((index, input) => {
                    if ($(input).val() !== "null" && $(input).val() !== "") {
                        empty = false;
                    }
                });

                if (empty) {
                    element.remove();
                }
            });
        });
    }

    initAutoToggle() {
        $("input.is-invalid, select.is-invalid").closest(".card-body").parent().addClass("show");
    }
}

export default InitiativeBackend;